import { DataQueryParams } from 'common/src/query-params/DataQueryParams';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const addLineItemSubtypeService = async (body: any) =>
  await postRequest(API_BASE_PATHS.LINE_ITEM_SUBTYPES, {}, body);

export const deleteLineItemSubtypeService = async (id: string) =>
  await deleteRequest(`${API_BASE_PATHS.LINE_ITEM_SUBTYPES}/${id}`, {});

export const getLineItemSubtypesService = async (params?: DataQueryParams) =>
  await getRequest(
    API_BASE_PATHS.LINE_ITEM_SUBTYPES,
    formatQueryParams(params),
  );
